import router from './router'
import store from './store'
import NProgress from 'nprogress' // 进度条
import 'nprogress/nprogress.css'// progress bar style
import { getToken, removeToken } from '@/utils/auth' // getToken from cookie
import { Loading } from 'element-ui'
import { i18n } from '@/lang'

NProgress.configure({ showSpinner: false })// NProgress Configuration
const whiteList = ['/login', '/404', '/app/app_login', '/app/app_white', '/oketpwd']// no redirect whitelist
router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  if (getToken()) { // determine if there has token
    /* has token */
    if (to.path === '/oketpwd') {
      removeToken()
      location.reload()
    } if (to.path === '/login') {
      // 下一个路由
      next({ path: '/home' })
      NProgress.done()
    } else if (to.path === '/app/app_login') {
      // 下一个路由
      removeToken()
      sessionStorage.removeItem('token')
      next('/app/app_login')
    } else {
      if (!store.getters.addRouters.length) { // 判断当前用户是否已拉取完user_info信息
        let loading = ''
        loading = Loading.service({
          lock: true,
          text: i18n.t('lang.数据加载中'),
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.0)'
        })
        store.dispatch('GetInfo').then(() => {
          loading.close()
          next({ ...to })
        })
      } else {
        next()
      }
    }
  } else {
    /* has no token */
    if (whiteList.indexOf(to.path) !== -1) { // 免登录白名单
      next()
    } else if (to.path.startsWith('/task_management/app_work_task')) {
      next()
    } else {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|phone|pad|pod|ios|Mobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|Symbian|Windows Phone/i.test(navigator.userAgent)) {
        next('/app/app_login')
      } else {
        next('/login') // 否则全部重定向到web登录页
      }
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})
router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js